export default __webpack_public_path__ + "static/media/creasy2game.8ac0e523.png";